<template>
  <el-dialog
    :title="$_t('BUTTON_APPROVALPROGRESS', '审批进度')"
    class="plat-icon-flowListDialog"
    :visible.sync="dialogVisible"
    @close="close"
  >
    <rt-flow-approval-list
      v-if="dialogVisible"
      :id="entityId"
      ref="rtFlowApprovalList"
      :entityname="entityname"
    ></rt-flow-approval-list>
  </el-dialog>
</template>
<script>
import RtFlowApprovalList from './flow-approval-list.vue';
export default {
  name: 'RtFlowApprovalDialog',
  components: {
    RtFlowApprovalList
  },
  props: ['entityname', 'id', 'value'],
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    entityId: function () {
      return this.id;
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.dialogVisible = newVal;
      if (this.dialogVisible) {
      }
    }
  },
  methods: {
    // 给动态表单使用
    show() {
      this.dialogVisible = true;
      if (this.$refs.rtFlowApprovalList) {
        this.$refs.rtFlowApprovalList.dataBind();
      }
    },
    close() {
      this.dialogVisible = false;
      this.$emit('input', this.dialogVisible);
    }
  }
};
</script>



// WEBPACK FOOTER //
// flow-approval-dialog.vue?4f8de8e0